<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.38838 2C9.69568 2 9.99535 2.14816 10.1592 2.41274L15.881 11.5884C16.0397 11.8436 16.0397 12.1563 15.881 12.4115L10.1617 21.5883C9.91662 21.9811 9.37568 22.1175 8.94775 21.8894C8.52236 21.6624 8.37633 21.1579 8.62141 20.764L14.0842 11.9999L8.61887 3.2347C8.37379 2.84195 8.51982 2.33749 8.94521 2.11054C9.08489 2.03528 9.23854 2 9.38838 2Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconChevronRight",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
